<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">


      <!-- <app-lab-sidebar></app-lab-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">

              <div class="card-header heading_n_button_box card-header-cus-new-appoint card-header-responsive">

                <div class="card-heading">
                  <h4>Sample Collection Center Employees</h4>
                </div>

                <div class="button-section mt-1">
                  <button type="button" class="mr-4 small-btn-dash mt-6px"
                    (click)="viewAddEmployee(addEmployeeModal); initialiseForm(); isEdit = false; isDisabled=false">Add
                    Employee <i class="far fa-plus-square"></i></button>
                </div>
              </div>

              <div class="card-body">


                <div class="col-lg-12 ">

                  <div class="">

                    <form [formGroup]="searchForm" (ngSubmit)="onSubmitSearch(searchForm.value)">
                      <div class="row">
                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <input name="employee_name" formControlName="employee_name" id="employee_name" type="text"
                            class="form-control col-lg-12" placeholder="Enter Employee Name">
                        </div>

                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <input name="employee_email" formControlName="employee_email" id="employee_email" type="text"
                            class="form-control col-lg-12" placeholder="Enter Employee Email">
                        </div>


                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <input name="employee_phone" formControlName="employee_phone" id="employee_phone" type="text"
                            class="form-control col-lg-12" placeholder="Enter Employee Phone">
                        </div>


                        <div class="col-lg-3  col-sm-6  col-md-6  mt-320_view">
                          <div class="mr-4 ">
                            <button type="submit" class="btn btn-secondary  theme-btn-2 dropdown-toggle-no"
                              id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false">
                              <i class="fas fa-search"></i> Search
                            </button>


                            <button class="btn btn-secondary  theme-btn-2 dropdown-toggle-no ml-2" type="button"
                              id="dropdownMenuButton" aria-haspopup="true" aria-expanded="false"
                              (click)="clearSearch()">
                              <i class="fas fa-sync-alt"></i> Clear
                            </button>

                          </div>
                        </div>
                      </div>
                    </form>

                  </div>



                  <div class="">
                    <div class="table-responsive mt-3">


                      <div class="col-auto">
                        <div class="row" *ngIf="collectionCenterEmployees">
                          <div class="show-record mt-3 mbm-32">
                            <span>Show</span> &nbsp;
                            <select class="custom-select custom-select-sm form-control form-control-sm"
                              (change)="setItemsPerPage(page.value)" #page>
                              <option [selected]="currentPageLength==10">10</option>
                              <option [selected]="currentPageLength==30">30</option>
                              <option [selected]="currentPageLength==50">50</option>
                              <option [selected]="currentPageLength==100">100</option>
                              <option [selected]="currentPageLength==500">500</option>
                              <option [selected]="currentPageLength==1000">1000</option>
                            </select> &nbsp;
                            <span> entries</span>
                          </div>
                        </div>
                      </div>

                      <table *ngIf="collectionCenterEmployees"
                        class="table table-bordered table-condensed table-responsive-sm table-responsive-md table-responsive-lg table-responsive-xl nowrap"
                        datatable [dtOptions]="dtOptions" width="100%">
                        <thead class="">
                          <tr>
                            <th scope="col">S/N</th>
                            <th scope="col">Name</th>
                            <th scope="col">Email Address</th>
                            <th scope="col">Phone Number</th>
                            <!-- TODO: This will be uncommented when the sample center object in included in the employee list response data -->
                            <!-- <th scope="col">Sample Collection Center</th> -->
                            <th>Status</th>
                            <th>Created At</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody class="dashboard-bg-white">

                          <tr *ngFor="let employee of collectionCenterEmployees | paginate: config; index as i">
                            <td>{{config.itemsPerPage * (config.currentPage - 1) + i + 1}}</td>
                            <td>{{employee.name}}</td>
                            <td>{{employee.email}}</td>
                            <td>{{employee.phone}}</td>
                            <!-- <td>Center 4</td> -->
                            <td>
                              <span *ngIf="employee.status" class="active-btn">Active</span>
                              <span *ngIf="!employee.status" class="inactive-btn">Inactive</span>
                            </td>
                            <td>{{employee.created_at | date: 'medium'}}</td>
                            <td>
                              <button title="View employee" type="button" class="btn-view mr-2"
                                (click)="showDetails(employee, showDetailsModal)"><i class="far fa-eye"></i></button>
                              <button title="Edit employee" type="button" class="btn-view"
                                (click)="showEditEmployee(employee, addEmployeeModal); isEdit = true"><i class="far fa-edit"></i></button>
                            </td>
                          </tr>

                        </tbody>
                      </table>

                      <div class="table-footer">
                        <div id="page_info" class="mt-3 record-show-text-bottom" *ngIf="collectionCenterEmployees">
                          Showing {{(config.currentPage-1) * config.itemsPerPage + 1}} - {{config.currentPage *
                          config.itemsPerPage}}
                          of {{ config.totalItems }} entries
                        </div>

                        <div class="pagination paging-pull-right" *ngIf="collectionCenterEmployees">
                          <pagination-controls (pageChange)="pageChange($event)"
                            class="my-pagination mt-2 pagination-server">
                          </pagination-controls>
                        </div>
                      </div>

                    </div>
                  </div>

                </div>

              </div>

            </div>
          </div>
        </div>
      </div>


    </div>

  </div>
</div>




<ng-template #addEmployeeModal let-modal>
  <div class="card mb-5 ">
    <div class="card-header heading_n_button_box">
      <h3 class="heading-responsive"> {{isEdit ? 'Edit' : 'Add'}} Employee</h3>
      <button type="button" class="close-button" (click)="modal.close('Save click')"><i
          class="fas fa-times"></i></button>
    </div>
    <div class="card-body p-4">
      <form [formGroup]="addEmployeeForm" (ngSubmit)="onSubmitEmployee(addEmployeeForm.value)">
        <div class="row">

          <div class="col-md-6 col-lg-4 col-sm-12  mt-3">
            <label class="form-label">Name Of Employee<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>

            <input type="text" class="form-control" id="name" formControlName="name"
              placeholder="Name of employeee e.g John Doe"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.name.errors }">


            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.name.errors" class="form-text text-danger">
              <div *ngIf="addEmployeeForm.controls.name.errors.required">Employee Name is required</div>
              <div *ngIf="addEmployeeForm.controls.name.errors.maxlength"> Employee Name must be under 45 characters
              </div>
              <div *ngIf="addEmployeeForm.controls.name.errors.pattern">Employee Name must be only alphabets</div>
            </div>

          </div>

          <div class="col-md-6 col-lg-4 col-sm-12  mt-3">
            <label class="form-label">Email Address<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
            <input type="email" class="form-control" formControlName="emailAddress" id="emailAddress"
              [attr.disabled]="isDisabled ? '' : null"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.emailAddress.errors }"
              placeholder="Email address e.g example@example.com">
            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.emailAddress.errors"
              class="form-text text-danger">
              <div *ngIf="addEmployeeForm.controls.emailAddress.errors.required">Email is required</div>
              <div *ngIf="addEmployeeForm.controls.emailAddress.errors.pattern">Please enter a valid email</div>
              <div *ngIf="addEmployeeForm.controls.emailAddress.errors.maxlength">Email must be under 45 characters
              </div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 col-sm-12  mt-3">
            <label class="form-label">Phone Number<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
            <input type="text" class="form-control" formControlName="phoneNumber" maxlength="11"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.phoneNumber.errors }"
              placeholder="Phone Number e.g 08054345678">

            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.phoneNumber.errors" class="form-text text-danger">

              <div *ngIf="addEmployeeForm.controls.phoneNumber.errors.required">Phone
                Number is required
              </div>
              <div *ngIf="addEmployeeForm.controls.phoneNumber.errors.minlength">Phone Number must
                be at least 11 digit long</div>
              <div *ngIf="addEmployeeForm.controls.phoneNumber.errors.maxlength">Phone Number must
                be at most 11 digit long</div>
              <div *ngIf="addEmployeeForm.controls.phoneNumber.errors.pattern">Phone Number must
                be numbers only and start with 0</div>

            </div>

          </div>

          <div class="col-md-6 col-lg-4 col-sm-12  mt-3">
            <label class="form-label">Contact Address<sup class="ml-1 font-weight-bolder text-danger">*</sup></label>
            <input type="text" class="form-control" formControlName="contactAddress"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.contactAddress.errors }"
              placeholder="Contact Address">
            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.contactAddress.errors"
              class="form-text text-danger">
              <div *ngIf="addEmployeeForm.controls.contactAddress.errors.required">Contact Address is
                required</div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 col-sm-12  mt-3">
            <label class="form-label">Sample Collection Center<sup
                class="ml-1 font-weight-bolder text-danger">*</sup></label>
            <select type="text" class="form-control" formControlName="collectionCenter" placeholder=""
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.collectionCenter.errors }">
              <option value="">Select Center</option>
              <option *ngFor="let center of shared.collectionCenters" [value]="center.id">
                {{center.name}} :: {{center.phone}}
              </option>
            </select>
            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.collectionCenter.errors"
              class="form-text text-danger">
              <div *ngIf="addEmployeeForm.controls.collectionCenter.errors.required">Sample Center is required</div>
            </div>
          </div>

          <div class="col-md-6 col-lg-4 col-sm-12  mt-3">
            <label class="form-label">Status<sup
                class="ml-1 font-weight-bolder text-danger">*</sup></label>
            <select type="text" class="form-control" formControlName="status" placeholder=""
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; addEmployeeForm.controls.status.errors }">
              <option value="">Select status</option>
              <option value="Active">
                Active
              </option>
              <option value="Inactive">
                Inactive
              </option>
            </select>
            <div *ngIf="submitted &amp;&amp; addEmployeeForm.controls.status.errors"
              class="form-text text-danger">
              <div *ngIf="addEmployeeForm.controls.status.errors.required">Status is required</div>
            </div>
          </div>

          <div class="col-md-12 mt-5 text-center"><button type="submit"
              class="btn btn-primary theme-btn">Submit</button></div>
        </div>
      </form>

    </div>
  </div>
</ng-template>

<ng-template #showDetailsModal let-modal>

  <div class="card col-lg-12">
    <div class="row">
      <div class="card-header col-lg-12 header-dashboard-button-2">
        <h3 class="heading-responsive">Employee Profile</h3>
        <button type="button" class="close-button" (click)="modal.close('Save click')"><i class="fas fa-times"></i></button>
      </div>
      <div class="card-body p-4">

        <!-- START  -->
        <div class="container">
          <div class="main-body">

            <!-- Breadcrumb -->
            <!-- <nav aria-label="breadcrumb" class="main-breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">Menu 1</a></li>
                    <li class="breadcrumb-item"><a href="#">Menu 2</a></li>
                    <li class="breadcrumb-item"><a href="#">Menu 3</a></li>
                  </ol>
                </nav> -->
            <!-- /Breadcrumb -->

            <div class="row gutters-sm">
              <div class="col-md-12 col-lg-4 mb-3">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex flex-column align-items-center text-center">
                      <img [src]="employeeSingleResponse?.profile_image" alt="" class="rounded-circle" width="150">
                      <div class="mt-3">
                        <h4>{{employeeSingleResponse?.name}}</h4>
                        <p class="text-secondary mb-1">{{employeeSingleResponse?.role?.display_name}}</p>
                        <p class="text-muted font-size-sm"> {{employeeSingleResponse?.address}}</p>

                        <div *ngIf="employeeSingleResponse.status">
                          <span class="btn btn-primary theme-btn">ACTIVE</span>
                        </div>
                        <div *ngIf="!employeeSingleResponse.status">
                          <span class="btn btn-danger">INACTIVE</span>
                        </div>


                        <!-- <button class="btn btn-outline-primary">BTN 2</button> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card mt-3">
                  <ul class="list-group list-group-flush">

                    <li class="list-group-item d-flex justify-content-between align-items-center flex-wrap">
                      <span class="text-secondary">Date Created: </span>
                      <span class="text-secondary">{{employeeSingleResponse?.created_at | date :'medium'}}</span>
                    </li>

                  </ul>
                </div>
              </div>
              <div class="col-md-12 col-lg-8 ">
                <div class="card mb-3">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-3">
                        <h6 class="mb-0">Full Name</h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        {{employeeSingleResponse?.name}}
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-sm-3">
                        <h6 class="mb-0">Email</h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        {{employeeSingleResponse?.email}}
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-sm-3">
                        <h6 class="mb-0">Phone</h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        {{employeeSingleResponse?.email}}
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-sm-3">
                        <h6 class="mb-0">Last Login</h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        {{employeeSingleResponse?.last_login | date: 'medium'}}
                      </div>
                    </div>
                    <hr>
                    <div class="row">
                      <div class="col-sm-3">
                        <h6 class="mb-0">Address</h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        {{employeeSingleResponse?.address}}
                      </div>
                    </div>
                    <hr>
                    <!-- <div class="row">
                      <div class="col-sm-3">
                        <h6 class="mb-0">Center Name</h6>
                      </div>
                      <div class="col-sm-9 text-secondary">
                        {{employeeSingleResponse?.address}}
                      </div>
                    </div>
                    <hr> -->
                    <div class="row">
                      <div class="col-sm-12">
                        <button type="button" class="btn btn-primary theme-btn"
                          (click)="showEditEmployee(employeeSingleResponse, addEmployeeModal); isEdit = true">Edit</button>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>

          </div>
        </div>
        <!-- END -->

      </div>
    </div>
  </div>


</ng-template>

<app-footer-dashboard></app-footer-dashboard>